module.exports = __webpack_public_path__ + "static/media/codePeaches.fd024113.png";